export type TGetBankReconcileTransactionsParams = {
  page: number;
  record: number;
  accountId: string;
  startDate: string;
  endDate: string;
  status: number;
  transactionReference: string;
};

export type TGetBankReconcileTransactionFilters = Omit<
  TGetBankReconcileTransactionsParams,
  "page" | "record"
>;

export interface IBankReconcileTransactions {
  hasNextPage: boolean;
  transactions: IBankReconcileTransactionEntity[];
}
export interface IBankReconcileTransactionEntity {
  id: string;
  transactionReference: string;
  amount: number;
  currency: string;
  transactionType: "AR" | "AP";
  transactionDate: string;
  transactionDateTime: string;
  remainingAmont: number;
  status: number;
  statusStr: string;
  syncedOn: string;
}

export const RECONCILIATION_STATUS = {
  Pending: 0,
  Reconciled: 1,
  PartialReconcile: 2,
  All: -1,
};
